import React from "react"

export function logToServer(err) {
  let message = err ? err.toString() : "No data"
  if (err && err instanceof Error && err.stack) {
    message = err.stack
  }

  if (window.lanzacofee_log_js_error) {
    window.lanzacofee_log_js_error(message)
  } else {
    console.error("Attempting to log client error, but no transport available", message)
  }
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidCatch(err, info) {
    logToServer(err)

    this.setState({
      err,
      info,
    })
  }

  render() {
    if (this.state.err) {
      return (
        <div className={"error-message"}>
          {this.state.err.toString()} ({this.state.info && this.state.info.toString()})
        </div>
      )
    } else {
      return this.props.children
    }
  }
}
